import { useCallback, useState } from 'react'
import Cookies from 'js-cookie'
import message from 'antd/lib/message'
import { useAuth0 } from '@auth0/auth0-react'
// import { setUserAction, setUserOrganisation } from '../store/root';
// import { IUser } from '../types/ICommon';
// import HeimdallService from '../services/HeimdallService';
// import { eOrgType } from '../enums/eShared';
// import { FE_PLAYMENT_ADMIN_ORG_ID } from '../common/constants';
import useService from './useService'
import {
    checkForUserSession,
    deleteLocalSession,
    getBearerToken,
    getRedirectUri,
} from '../utils/auth.utils'
import { appConfig } from '../config/app.config'
import { useDispatch } from 'react-redux'
import { setUserAction } from '../store/auth/auth.slice'
import { set } from 'idb-keyval'
import { userSessionCookie } from 'src/constants/auth.constants'

const useAuthentication = () => {
    const [customMessage, setCustomMessage] = useState('')
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const { isLoading: isAuthLoading } = useAuth0()
    const dispatch = useDispatch()

    console.log(
        'ENV_BUILD_ENVIRONMENT',
        process.env.ENV_BUILD_ENVIRONMENT,
        'NODE_ENV',
        process.env.NODE_ENV
    )
    /* check if url has orgId in it */

    // const hash = window.location.href?.split('#')[1];
    // const orgId = hash?.split('/')[1];

    const { trigger, error, isLoading } = useService(
        useCallback(async () => {
            try {
                const profile = await checkForUserSession()
                Cookies.set(userSessionCookie, JSON.stringify(profile), {
                    expires: 14,
                })
                /**
                 * Store the auth token in indexed db
                 */
                await set('auth-token', profile.token)
                dispatch(setUserAction(profile))
                return profile
            } catch (err) {
                console.error(err)
                if (
                    (err as { message: string }).message == 'login_required' ||
                    (err as { message: string }).message.includes('There was an error') ||
                    (err as { message: string }).message.includes('Incorrect time error')
                ) {
                    deleteLocalSession()
                    setCustomMessage('Please wait while we redirect you to the login')
                    window.location.replace(
                        `${appConfig.jarvisBaseUrl}?redirect_uri=${encodeURIComponent(
                            getRedirectUri()
                        )}&error=${encodeURIComponent((err as { message: string }).message)}`
                    )
                } else {
                    message.error('Something went wrong. Please try after some time.')
                }
                return Promise.reject(err)
            } finally {
                if (getBearerToken()) {
                    setIsAuthenticated(true)
                }
            }
        }, [dispatch])
    )

    return {
        trigger,
        customMessage,
        error,
        isLoading: isAuthLoading || isLoading,
        isAuthenticated,
    }
}

export default useAuthentication
